import { AutoComplete, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAllEstablishmentsList } from "../../../../../../../services/ticketAutomationReceivedRuleEstablishment.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const EstablishmentExternalId = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(getAllEstablishmentsList);

  const [options, setOptions] = useState<ISelectType[]>([]);

  const fetchOptions = useCallback(async () => {
    const { data, success } = await sendRequest({});
    if (data && success) {
      setOptions(
        data
          .filter((item) => !!item.code)
          .map((item) => ({ id: item.code as string, name: item.name })),
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        options={options}
        name="establishmentExternalId"
        size="small"
        fullWidth
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "establishment_external_id")}
      />
    </Grid>
  );
});
